<template>
    <v-avatar v-if="uri || !loaded || bot" :size="actual_size"
    :image="bot ? undefined : uri"
    :style="bot ? `background-color:${color};color:white;` : ''"
    >
    <v-icon v-if="bot" :icon="bot" :style="`transform: scale(${scale_kf})`"></v-icon>
    </v-avatar>
    <div v-else class="avatar" :style="`width:${actual_size}px;height:${actual_size}px;background:${color};`">
        <p :style="`width:${actual_size - 2}px;height:${actual_size - 2}px;font-size:${actual_size * 0.5}px;`">
            {{ literals }}
        </p>
    </div>
</template>

<script>
import { reactive } from 'vue';
import { MD5 } from '../md5';

const strhash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i += 1) {
        // eslint-disable-next-line no-bitwise
        hash = str.charCodeAt(i) + ((hash << 2) - hash);
    }
    hash = Math.abs(hash);
    return hash;
};

const clamp = (hash, min, max) => Math.floor((hash % (max - min)) + min);

const database = () => new Promise((resolve, reject) => {
    const req = indexedDB.open('avatars_db', 1);
    req.onupgradeneeded = (e) => {
        const db = req.result;
        switch (e.oldVersion) {
        case 0:
            db.createObjectStore('avatars', {
                keyPath: 'id',
            });
            break;
        default:
            break;
        }
    };
    req.onsuccess = () => {
        const db = req.result;
        resolve(db);
    };
    req.onerror = (e) => {
        reject(e);
    };
});

const cache = reactive({});

export default {
    name: 'AvatarView',
    data() {
        return {
            default_size: 32,
        };
    },
    props: {
        size: {
            type: Number,
            default: undefined,
        },
        id: String,
        user: Object,
        status: {
            type: Number,
            default: undefined,
        },
    },
    computed: {
        account() {
            if (this.user) {
                return this.user;
            }
            return this.$api.get_user(this.id);
        },
        email() {
            const account = this.account;
            return account?.email || account?.uid || account?.id;
        },
        color() {
            if (this.bot) {
                return 'hsl(119,94%,32%)';
            }
            const hash = strhash(this.email || '');
            const h = clamp(hash, 0, 360);
            const s = clamp(hash, 30, 100);
            const l = clamp(hash, 30, 60);
            return `hsl(${h},${s}%,${l}%)`;
        },
        literals() {
            const account = this.account;
            if (account) {
                const variants = [];
                const name = account.name?.trim();
                const surname = account.surname?.trim();
                const patronymic = account.patronymic?.trim();
                if ((name) && (name.length > 0)) {
                    variants.push(name[0]);
                }
                if ((surname) && (surname.length > 0)) {
                    variants.push(surname[0]);
                }
                if ((patronymic) && (patronymic.length > 0)) {
                    variants.push(patronymic[0]);
                }
                if (variants.length >= 2) {
                    return `${variants[0]}${variants[1]}`.toUpperCase();
                } if (variants.length > 0) {
                    return variants[0].toUpperCase();
                }
            }
            return '';
        },
        hash() {
            const email = this.email || '';
            return MD5(email);
        },
        aid() {
            return `${this.hash}?${this.actual_size}`;
        },
        ssize() {
            let scale = window.devicePixelRatio;
            if (scale == null) {
                scale = 1.0;
            }
            return Math.round(this.actual_size * scale);
        },
        uri() {
            const size = this.ssize;
            const hash = this.hash;
            const id = this.aid;
            const data = cache[id];
            const update = Date.now();
            if (data) {
                if (update - data.update > 60 * 60 * 1000) {
                    this.fetch(id, hash, size);
                }
                return data.uri;
            }
            cache[id] = {
                id,
                uri: null,
                blob: null,
                update,
            };
            this.loadb(id);
            return cache[id].uri;
        },
        loaded() {
            return cache[this.aid].loaded;
        },
        bot() {
            return this.id === '68cd405d6e8533907872c2d6' || 
                this.hash === '6f37330d6786b7de2cfb8c84964f4bac' ? 'mdi mdi-robot-happy-outline': undefined;
        },
        actual_size() {
            return this.size ? this.size : this.default_size;
        },
        scale_kf() {
            return this.actual_size/this.default_size;
        }
    },
    methods: {
        loadb(id) {
            database().then((db) => {
                const transaction = db.transaction('avatars', 'readonly');
                const store = transaction.objectStore('avatars');
                const req = store.get(id);
                req.onsuccess = () => {
                    const data = req.result || {
                        id,
                        uri: null,
                        blob: null,
                        update: 0,
                    };
                    if (data.blob) {
                        data.uri = URL.createObjectURL(data.blob);
                    }
                    if (req.result) {
                        data.loaded = true;
                    }
                    cache[id] = data;
                };
                req.onerror = () => {
                    cache[id] = {
                        id,
                        uri: null,
                        blob: null,
                        update: 0,
                    };
                };
            });
        },
        savedb(id, blob) {
            const data = {
                id,
                blob,
                update: Date.now(),
            };
            if (blob) {
                data.uri = URL.createObjectURL(blob);
            }
            cache[id] = data;
            data.loaded = true;
            database().then((db) => {
                const transaction = db.transaction('avatars', 'readwrite');
                const store = transaction.objectStore('avatars');
                store.put({
                    id,
                    blob,
                    update: Date.now(),
                });
            });
        },
        fetch(id, hash, size) {
            cache[id].update = Date.now();
            fetch(`https://www.gravatar.com/avatar/${hash}?s=${size}&r=pg&d=404`).then((data) => {
                if (data.ok) {
                    data.blob().then((blob) => {
                        this.savedb(id, blob);
                    }).catch(() => {
                        this.savedb(id, null);
                    });
                } else {
                    this.savedb(id, null);
                }
            }).catch(() => {
                this.savedb(id, null);
            });
        },
    },
};
</script>

<style scoped>
.avatar {
    border-radius: 50%;
    border: 1px solid rgba(200, 200, 200, 0.4);
    transition: linear 0.25s;
    user-select: none;
}

.v-list-item__prepend>.avatar {
    margin-inline-end: 16px;
}

.avatar:hover {
    transition: ease-out 0.2s;
    border: 1px solid rgba(0, 0, 0, 0.2);
}

.avatar p {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
}
</style>
